import React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  title: {
    color: '#424242',
  },
  subTitle: {
    paddingBottom: 5,
  },
  spanText: {
    color: 'black',
  },
};
const PurchaseSummary = props => {
  const { classes, summary } = props;
  return (
    <div>
      <Card>
        <CardContent>
          <Typography className={classes.title} variant="title">
            Purchase Summary
          </Typography>
          <br />
          <Typography
            className={classes.subTitle}
            variant="subheading"
            color="textSecondary"
          >
            Plan: <span className={classes.spanText}>{summary.name}</span>
          </Typography>
          <Typography
            className={classes.subTitle}
            variant="subheading"
            color="textSecondary"
          >
            Price:{' '}
            <span className={classes.spanText}>{`$${summary.price}`}</span>
            <span style={{ fontSize: '10px', padding: 5 }}>
              (billed annually)
            </span>
          </Typography>
          <Typography
            className={classes.subTitle}
            variant="subheading"
            color="textSecondary"
          >
            Shipping:{' '}
            <span className={classes.spanText}>{`$${summary.shipping}`}</span>
            <span style={{ fontSize: '10px', padding: 5 }}>
              (one time charge)
            </span>
          </Typography>
          <Typography
            className={classes.subTitle}
            variant="subheading"
            color="textSecondary"
          >
            Total:{' '}
            <span className={classes.spanText}>{`$${summary.total}`}</span>
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default withStyles(styles)(PurchaseSummary);



// WEBPACK FOOTER //
// ./src/components/PurchaseSummary.js